import { createContext, useState } from 'react';
import { apiV1 } from '../lib/axios';
import { toast } from 'react-toastify'; 

export const CardContext = createContext({});

export function CardProvider({ children }) {
  const [cards, setCards] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [cardRequests, setCardRequests] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [invoiceTransactions, setInvoiceTransactions] = useState([]);

  const getCardData = async () => {
    try {
      setLoading(true);
      const response = await apiV1.post('/cards/getinfos');
      if (response.status !== 200) {
        throw new Error('Erro ao carregar os dados do cartão');
      }
      const cards = response.data.data;
      setCards(cards);
    } catch (err) {
      toast.error('Erro ao carregar os dados do cartão');
    } finally {
      setLoading(false);
    }
  };
  
  const getInvoices = async () => {
    try {
      setLoading(true);
      const response = await apiV1.get('/cards/statement');
      if (response.status !== 200) {
        throw new Error('Erro ao carregar faturas');
      }
      const invoices = response.data.data;
      setInvoices(invoices);
    } catch (err) {
      toast.error('Erro ao carregar faturas');
    } finally {
      setLoading(false);
    }
  };

  const getInvoiceTransactions = async (invoiceId) => {
    try {
      const response = await apiV1.get(`/cards/statement/transactions/${invoiceId}`);
      if (response.status !== 200) {
        throw new Error ('Erro ao carregar transações do extrato');
      }
      const invoiceTransactions = response.data.data;
      setInvoiceTransactions(invoiceTransactions);
    } catch (err) {
      return toast.error('Erro ao carregar transações do extrato');
    }
  }

  const getCardRequests = async () => {
    try {
      setLoading(true);
      const response = await apiV1.get('/cards/request/status');
      if (response.status !== 200) {
        throw new Error ('Erro ao carregar status do cartão');
      }
      const requestCards = response.data.data;
      setCardRequests(requestCards);
    } catch (err) {
      return toast.error('Erro ao carregar status do cartão');
    } finally {
      setLoading(false);
    }
  }

  const updateCard = async (payload) => {
    try {
      const response = await apiV1.put('/cards/update', payload);
      if (response.status !== 200) {
        throw new Error('Erro ao atualizar dados do cartão');
      }
      return response.data.message;
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erro ao atualizar dados do cartão');
      throw err;
    }
  }

  const payInvoice = async (payload) => {
    try {
      const response = await apiV1.post('/cards/statement/payment', payload);
      if (response.status !== 200) {
        throw new Error ('Erro ao pagar extrato');
      }
      return response.data.message;
    } catch (err) {
      return toast.error('Erro ao pagar extrato');
    }
  }

  const requestCard = async (payload) => {
    try {
      const response = await apiV1.post('/cards/request',
        payload
      );
      if (response.status !== 200) {
        throw new Error ('Erro ao solicitar cartão');
      }
      return response.data.message;
    } catch (err) {
      throw err;
    }
  }

  

  return (
    <CardContext.Provider
      value={{
        cards,
        setCards,

        selectedCard, 
        setSelectedCard,

        cardRequests,
        setCardRequests,

        invoices,
        setInvoices,

        loading,
        setLoading,

        invoiceTransactions,
        setInvoiceTransactions,

        getCardData,
        getInvoices,
        getInvoiceTransactions,
        getCardRequests,
        updateCard,
        payInvoice,
        requestCard,
      }}
    >
      {children}
    </CardContext.Provider>
  );
}
